/* Menu week flip: Friday 00:00 Asia/Singapore. Same math as meal_selector.liquid. */
(function (root) {
  var MONTHS = {
    january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
    july: 7, august: 8, september: 9, october: 10, november: 11, december: 12
  };
  var WEEKDAY = { Sun: 7, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function isoFromParts(y, m, d) {
    return y + '-' + pad(m) + '-' + pad(d);
  }

  function dateDiffDays(a, b) {
    var am = /^(\d{4})-(\d{2})-(\d{2})$/.exec(a);
    var bm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(b);
    var au = Date.UTC(+am[1], +am[2] - 1, +am[3]);
    var bu = Date.UTC(+bm[1], +bm[2] - 1, +bm[3]);
    return Math.round((au - bu) / 86400000);
  }

  function singaporeParts(now) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Singapore',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short'
    });
    var parts = { year: 0, month: 0, day: 0, weekday: 0 };
    fmt.formatToParts(now).forEach(function (p) {
      if (p.type === 'year') parts.year = parseInt(p.value, 10);
      if (p.type === 'month') parts.month = parseInt(p.value, 10);
      if (p.type === 'day') parts.day = parseInt(p.value, 10);
      if (p.type === 'weekday') parts.weekday = WEEKDAY[p.value];
    });
    return parts;
  }

  function allowedMondayISO(now) {
    var p = singaporeParts(now || new Date());
    var weekOffset = p.weekday > 4 ? 7 : 0;
    var days = 8 - p.weekday + weekOffset;
    var utc = Date.UTC(p.year, p.month - 1, p.day) + days * 86400000;
    var dt = new Date(utc);
    return isoFromParts(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
  }

  function parseMenuDate(raw, allowedMonday) {
    if (!raw) return '';
    var s = String(raw).replace(/\s+/g, ' ').trim();
    var iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) return iso[1] + '-' + iso[2] + '-' + iso[3];
    var m = s.match(/^([A-Za-z]+)\s+(\d{1,2})(?:,?\s*(\d{4}))?$/);
    if (!m || !MONTHS[m[1].toLowerCase()]) return '';
    var month = MONTHS[m[1].toLowerCase()];
    var day = parseInt(m[2], 10);
    if (m[3]) return isoFromParts(parseInt(m[3], 10), month, day);
    var allowed = allowedMonday || allowedMondayISO(new Date());
    var year = parseInt(allowed.slice(0, 4), 10);
    var best = '';
    var bestDiff = Infinity;
    for (var y = year - 1; y <= year + 1; y++) {
      var candidate = isoFromParts(y, month, day);
      var diff = Math.abs(dateDiffDays(candidate, allowed));
      if (diff < bestDiff) {
        bestDiff = diff;
        best = candidate;
      }
    }
    return best;
  }

  function earliestISO(dateStrings, allowedMonday) {
    var live = allowedMonday || allowedMondayISO(new Date());
    var best = '';
    (dateStrings || []).forEach(function (raw) {
      var iso = parseMenuDate(raw, live);
      if (!iso) return;
      if (!best || iso < best) best = iso;
    });
    return best;
  }

  function serverMonday() {
    var el = document.querySelector('[data-allowed-monday]');
    return el ? el.getAttribute('data-allowed-monday') || '' : '';
  }

  function pageIsStale(now) {
    if (typeof document === 'undefined') return false;
    var live = allowedMondayISO(now || new Date());
    var server = serverMonday();
    if (server && server !== live) return true;
    var stale = false;
    document.querySelectorAll('.meal_selector_outter .date').forEach(function (el) {
      var iso = parseMenuDate(el.textContent, live);
      if (iso && iso < live) stale = true;
    });
    return stale;
  }

  /* One reload when the open tab is from the previous menu. Second attempt stops. */
  function holdCheckout() {
    if (typeof document === 'undefined') return false;
    var key = 'menu-cutoff-reloaded';
    if (!pageIsStale()) {
      try { sessionStorage.removeItem(key); } catch (e) {}
      return false;
    }
    var marker = serverMonday() || '1';
    try {
      if (sessionStorage.getItem(key) === marker) {
        window.alert('This menu has refreshed. Please reselect your meals.');
        return true;
      }
      sessionStorage.setItem(key, marker);
    } catch (e) {}
    window.location.reload();
    return true;
  }

  if (root && root.addEventListener) {
    root.addEventListener('pageshow', function (event) {
      if (event.persisted) root.location.reload();
    });
  }

  var api = {
    allowedMondayISO: allowedMondayISO,
    parseMenuDate: parseMenuDate,
    earliestISO: earliestISO,
    pageIsStale: pageIsStale,
    holdCheckout: holdCheckout
  };

  if (root) root.MenuCutoff = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : this);

if (typeof require !== 'undefined' && require.main === module) {
  var api = require('./menu-cutoff.js');
  function assert(cond, msg) {
    if (!cond) throw new Error(msg);
  }
  assert(api.allowedMondayISO(new Date('2026-10-16T04:53:00Z')) === '2026-10-26', 'Fri 16 Oct 12:53 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-15T15:59:00Z')) === '2026-10-19', 'Thu 15 Oct 23:59 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-18T16:00:00Z')) === '2026-10-26', 'Mon 19 Oct 00:00 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-20T02:00:00Z')) === '2026-10-26', 'Tue 20 Oct 10:00 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-22T15:59:00Z')) === '2026-10-26', 'Thu 22 Oct 23:59 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-22T16:00:00Z')) === '2026-11-02', 'Fri 23 Oct 00:00 SGT');
  assert(api.allowedMondayISO(new Date('2026-10-17T04:00:00Z')) === '2026-10-26', 'Sat 17 Oct');
  assert(api.allowedMondayISO(new Date('2026-10-18T04:00:00Z')) === '2026-10-26', 'Sun 18 Oct');
  assert(api.parseMenuDate('OCTOBER 19', '2026-10-26') === '2026-10-19', 'old week date');
  assert(api.parseMenuDate('November  2', '2026-10-26') === '2026-11-02', 'padded november');
  assert(api.parseMenuDate('January 4', '2026-12-28') === '2027-01-04', 'year wrap forward');
  assert(api.parseMenuDate('December 28', '2027-01-04') === '2026-12-28', 'year wrap back');
  assert(api.earliestISO(['OCTOBER 22', 'OCTOBER 19'], '2026-10-26') === '2026-10-19', 'earliest');
  assert(api.parseMenuDate('OCTOBER 19', '2026-10-26') < '2026-10-26', '19 Oct blocked on 16 Oct menu');
}
